import React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={38} height={33} viewBox="0 0 38 33" {...props}>
      <title>{"spell-check"}</title>
      <g fill="#161657" fillRule="nonzero">
        <path d="M9 23a1 1 0 00-1 1v.002A4.97 4.97 0 005 23c-2.756 0-5 2.244-5 5s2.244 5 5 5a4.982 4.982 0 003-1.002V32a1 1 0 002 0v-8a1 1 0 00-1-1zm-4 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM17 23a4.982 4.982 0 00-3 1.002V16a1 1 0 00-2 0v16a1 1 0 002 0v-.002A4.97 4.97 0 0017 33c2.756 0 5-2.244 5-5s-2.244-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM29 33c-2.756 0-5-2.244-5-5s2.244-5 5-5c.878 0 1.744.232 2.5.67a1 1 0 01-1 1.732 3.002 3.002 0 00-4.5 2.6 3.004 3.004 0 004.5 2.6 1 1 0 011.002 1.73 5.002 5.002 0 01-2.5.67L29 33zM23 16c-.256 0-.512-.098-.708-.292l-6-6a1 1 0 011.414-1.414l5.292 5.292L36.29.294a1 1 0 011.414 1.414l-14 14a.996.996 0 01-.708.292H23z" />
      </g>
    </svg>
  )
}

export const SpellcheckIcon = React.memo(SvgComponent)

SpellcheckIcon.displayName = "SpellcheckIcon"
